/**
 * Representation of the FeatureCollection-Object specified in GeoJSON-Standard.
 *
 * @class FeatureCollection
 * @extends Geometry
 */
export class PickData {
    constructor() {
        this.mx = -1;
        this.my = -1;
        this.feature = null;
        this.found = true;
        this.mindist = -1; //minimal distance to feature-geometrie
        this.disttopoint = -1; //minimal distance to nearest point on geometry
        this.pointindex = -1; //point index in features coordinate array
        this.found_mx = -1;
        this.found_my = -1;
        this.found_easting = -1; //easting of picked point or by pointindex defined point
        this.found_northing = -1; //easting of picked point or by pointindex defined point
        this.found_height = -1; //easting of picked point or by pointindex defined point
        this.geometry = null;
    }
}
//# sourceMappingURL=pickdataobject.js.map